import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { AccDeliveryService } from '../acc-delivery.service';
import { AccAwardsViewPart } from './awards/awards-view.part';
import { AccEnrollmentsViewPart } from './enrollments/enrollments-view.part';
import { AccEventsViewPart } from './events/events-view.part';
import { AccFinalPresentationViewPart } from './final-presentations/final-presentation-view.part';
import { AccGraduationViewPart } from './graduation/graduation-view.part';
import { AccProgressBySectionViewPart } from './progress-by-section/progress-by-section-view.part';
import { AccSessionsViewPart } from './sessions/sessions-view.part';
import { AccSurveysBySessionViewPart } from './surveys-by-session/surveys-by-session-view.part';
import { AccSurveysBySpecialistViewPart } from './surveys-by-specialist/surveys-by-specialist-view.part';
import { AccSurveysByTopicViewPart } from './surveys-by-topic/surveys-by-topic-view.part';
import { AccTopicSpecialistsViewPart } from './topic-specialists/topic-specialists-view.part';
import { AccTopicsViewPart } from './topics/topics-view.part';



@Component({
	selector: 'acc-delivery-views-part',
	standalone: true,
	imports: [
		AccEventsViewPart,
		AccSessionsViewPart,
		AccTopicsViewPart,
		AccTopicSpecialistsViewPart,
		AccSurveysBySessionViewPart,
		AccSurveysByTopicViewPart,
		AccSurveysBySpecialistViewPart,
		AccEnrollmentsViewPart,
		AccProgressBySectionViewPart,
		AccFinalPresentationViewPart,
		AccAwardsViewPart,
		AccGraduationViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-delivery-views.part.html',
})
export class AccDeliveryViewsPart {

	public pageService = inject(AccDeliveryService);

}